import { FlatItem } from 'src/types/elements.type';
import { http } from '@martech-solution/utils/utils';

const controller = 'hr/expense-types';

export const getExpenseTypesDropdown = async () => {
  return http.get<FlatItem[]>(`${controller}/dropdown`);
};
